<template>
  <div>
    <div class="dashboard__tab">
      <b-tabs>
        <b-tab title="All bookings" active>
          <select
            name=""
            v-model="sort"
            id=""
            class="form__select dashboard__filter"
          >
            <option :value="null" disabled selected>Filter</option>
            <option value="all">All</option>
            <option value="pending">Pending</option>
            <option value="accepted">Accepted</option>
            <option value="paid">Paid</option>
            <option value="rejected">Rejected</option>
            <option value="expired">Expired</option>
            <option value="expire-soon">Expire Soon</option>
            <option value="unavailable">Unavailable</option>
            <option value="past-due">Past Due</option>
            <option value="canceled">Canceled</option>
            <option value="cancelling">Cancelling</option>
          </select>
          <div class="dashboard__container ">
            <input
              type="text"
              class="form__input dashboard__search"
              v-model="searchQuery"
              placeholder="Search by member name"
              @keyup.enter="handleSearchBooking"
            />
            <svgicon
              icon="cancel"
              class="cancel_icon"
              @click.prevent="clearSearchBar"
            ></svgicon>
          </div>

          <div
            class="dashboard__payment-history-wrap dashboard__overview-table"
            v-if="bookings.length > 0 && returnedData"
          >
            <table class="dashboard__payment-history-table">
              <thead>
                <tr>
                  <th class="dashboard__payment-history-table-heading"></th>
                  <th class="dashboard__payment-history-table-heading">
                    Space name
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Member Name
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Host Name
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Space type
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Sub type
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    sub cost
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Booking Date
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Status
                  </th>
                </tr>
              </thead>
              <tbody>
                <router-link
                  tag="tr"
                  :to="
                    `/booking-details/${booking.id}?page=${getPages}&currentPage=${curPage}`
                  "
                  class="dashboard__table-row"
                  v-for="(booking, index) in filteredBooking"
                  :key="index"
                >
                  <td
                    class="dashboard__payment-history-table-data dashboard__listing-table"
                  >
                    {{ pageNumber(index + 1) }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ booking.space_name }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ `${booking.user_fullname}` }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ `${booking.host_fullname}` }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ booking.space_type | capitalize }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ booking.sub_plan | capitalize }}
                  </td>
                  <td
                    class="dashboard__payment-history-table-data"
                    v-html="sumPrices(booking.price_template)"
                  ></td>
                  <td class="dashboard__payment-history-table-data">
                    {{ formatDate(booking.created_at) }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    <span
                      class="dashboard__payment-history-table-status"
                      :class="[
                        { pending: booking.status == 'pending' },
                        { approve: booking.status == 'accepted' },
                        { approve: booking.status == 'paid' },
                        { rejected: booking.status == 'rejected' },
                        { expired: booking.status == 'expired' },
                        { expired: booking.status == 'unavailable' },
                        { decline: booking.status == 'inactive' },
                        { expireSoon: booking.status == 'expire-soon' },
                        { pastDue: booking.status == 'past-due' },
                        { cancelling: booking.status == 'cancelling' }
                      ]"
                      >{{ booking.status | capitalize }}</span
                    >
                  </td>
                </router-link>
              </tbody>
            </table>
          </div>
          <!-- Empty booking result -->
          <div v-if="!loader && bookings.length === 0 && !error">
            <empty-result />
          </div>
          <!-- error-->
          <div v-if="!loader && error">
            <error />
          </div>

          <div class="dashboard__pagination">
            <b-pagination
              v-if="bookings.length > 0 && returnedData"
              pills
              v-model="curPage"
              :total-rows="count"
              :per-page="pageSize"
              prev-text="Prev"
              next-text="Next"
              first-number
              last-number
              @change="handlePagination"
            ></b-pagination>
          </div>
        </b-tab>

        <b-tab title="Pending member kyc bookings">
          <div
            class="dashboard__payment-history-wrap dashboard__overview-table"
            v-if="bookings.length > 0 && returnedData"
          >
            <table class="dashboard__payment-history-table">
              <thead>
                <tr>
                  <th class="dashboard__payment-history-table-heading">
                    Space name
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Member Name
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Host Name
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Space type
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Sub type
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    sub cost
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Booking Date
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Status
                  </th>
                </tr>
              </thead>
              <tbody>
                <router-link
                  tag="tr"
                  :to="'/member-details/' + booking.user_id"
                  class="dashboard__table-row"
                  v-for="(booking, index) in unapprovedKYC"
                  :key="index"
                >
                  <td class="dashboard__payment-history-table-data">
                    {{ booking.space_name }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ `${booking.user_fullname}` }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ `${booking.host_fullname}` }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ booking.space_type | capitalize }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ booking.sub_plan | capitalize }}
                  </td>
                  <td
                    class="dashboard__payment-history-table-data"
                    v-html="sumPrices(booking.price_template)"
                  ></td>
                  <td class="dashboard__payment-history-table-data">
                    {{ formatDate(booking.created_at) }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    <span
                      class="dashboard__payment-history-table-status"
                      :class="[
                        { pending: booking.status == 'pending' },
                        { approve: booking.status == 'accepted' },
                        { approve: booking.status == 'paid' },
                        { rejected: booking.status == 'rejected' },
                        { expired: booking.status == 'expired' },
                        { expired: booking.status == 'unavailable' },
                        { decline: booking.status == 'inactive' },
                        { expireSoon: booking.status == 'expire-soon' },
                        { pastDue: booking.status == 'past-due' },
                        { cancelling: booking.status == 'cancelling' }
                      ]"
                      >{{ booking.status | capitalize }}</span
                    >
                  </td>
                </router-link>
              </tbody>
            </table>
          </div>
        </b-tab>

        <b-tab title="Pending guarantor bookings">
          <div
            class="dashboard__payment-history-wrap dashboard__overview-table"
            v-if="bookings.length > 0 && returnedData"
          >
            <table class="dashboard__payment-history-table">
              <thead>
                <tr>
                  <th class="dashboard__payment-history-table-heading">
                    Space name
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Member Name
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Host Name
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Space type
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Sub type
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    sub cost
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Booking Date
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Status
                  </th>
                </tr>
              </thead>
              <tbody>
                <router-link
                  tag="tr"
                  :to="'/booking-details/' + booking.id"
                  class="dashboard__table-row"
                  v-for="(booking, index) in unapproveGuarantor"
                  :key="index"
                >
                  <td class="dashboard__payment-history-table-data">
                    {{ booking.space_name }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ `${booking.user_fullname}` }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ `${booking.host_fullname}` }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ booking.space_type | capitalize }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    {{ booking.sub_plan | capitalize }}
                  </td>
                  <td
                    class="dashboard__payment-history-table-data"
                    v-html="sumPrices(booking.price_template)"
                  ></td>
                  <td class="dashboard__payment-history-table-data">
                    {{ formatDate(booking.created_at) }}
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    <span
                      class="dashboard__payment-history-table-status"
                      :class="[
                        { pending: booking.status == 'pending' },
                        { approve: booking.status == 'accepted' },
                        { approve: booking.status == 'paid' },
                        { rejected: booking.status == 'rejected' },
                        { expired: booking.status == 'expired' },
                        { expired: booking.status == 'unavailable' },
                        { decline: booking.status == 'inactive' },
                        { expireSoon: booking.status == 'expire-soon' },
                        { pastDue: booking.status == 'past-due' },
                        { cancelling: booking.status == 'cancelling' }
                      ]"
                      >{{ booking.status | capitalize }}</span
                    >
                  </td>
                </router-link>
              </tbody>
            </table>
          </div>
        </b-tab>
      </b-tabs>
    </div>

    <loader :loader="loader"></loader>
  </div>
</template>
<script>
import loader from "../resuables/loader";
import { getBookings } from "../../../services/booking";
import EmptyResult from "../general/emptyResult.vue";
import Error from "../general/error.vue";
import {
  formatCurrencyAmount,
  sumBookingPrice,
  formatReadbleDate
} from "../../utils";
export default {
  name: "BookingTable",
  components: {
    loader,
    EmptyResult,
    Error
  },
  data: () => {
    return {
      bookings: [],
      loader: false,
      returnedData: true,
      sort: "all",
      filteredBooking: [],
      searchQuery: "",
      unapprovedKYC: null,
      unapproveGuarantor: null,
      currentPage: 1,
      pageSize: 20,
      count: 0,
      page: 1,
      status: "",
      error: false
    };
  },
  methods: {
    clearSearchBar() {
      this.searchQuery = "";
      this.getBookings();
    },
    handleSearchBooking() {
      this.$router.replace(
        `/booking?page=1&status=${this.status}&name=${this.searchQuery}`
      );
      this.getBookings();
    },
    getBookings() {
      this.loader = true;
      getBookings(this.getPages, this.pageSize, this.status, this.searchQuery)
        .then(data => {
          this.loader = false;
          this.bookings = data.data.bookings;
          this.count = data.data.totalBookings;
          this.filteredBooking = this.bookings;
          this.unapprovedKYC = this.bookings.filter(kyc => {
            if (
              kyc.member_kyc_status == "pending" ||
              kyc.member_kyc_status == "declined"
            ) {
              return kyc;
            }
          });
          this.unapproveGuarantor = this.bookings.filter(guarantor => {
            if (guarantor.guarantor_approved == false) {
              return guarantor;
            }
          });
          this.unapproveGuarantor.sort(
            (d1, d2) =>
              new Date(d2.updated_at).getTime() -
              new Date(d1.updated_at).getTime()
          );
          this.unapprovedKYC.sort(
            (d1, d2) =>
              new Date(d2.updated_at).getTime() -
              new Date(d1.updated_at).getTime()
          );
          this.filteredBooking.sort(
            (d1, d2) =>
              new Date(d2.updated_at).getTime() -
              new Date(d1.updated_at).getTime()
          );
        })
        .catch(err => {
          this.loader = false;
          this.error = true;
          return err;
        });
    },
    handlePagination(value) {
      this.currentPage = value;
      this.$router.push(
        `/booking?page=${this.currentPage}&status=${this.status}&name=${this.searchQuery}`
      );
    },
    sumPrices(priceData) {
      return sumBookingPrice(priceData);
    },
    formatDate(date) {
      return formatReadbleDate(date);
    },
    toBase64(data) {
      return btoa(data);
    },

    pageNumber(index) {
      if (this.currentPage < 2) {
        return index;
      } else {
        return this.pageSize * (this.currentPage - 1) + index;
      }
    }
  },
  watch: {
    $route() {
      this.getBookings();
    },
    sort(newValue) {
      this.currentPage = 1;
      if (newValue === "all") {
        this.status = "";
        this.$router.replace(`/booking?page=1`);
        this.getBookings();
      } else {
        this.status = newValue;
        this.$router.replace(`/booking?page=1&status=${this.status}`);
        this.getBookings();
      }
    }
  },
  filters: {
    capitalize(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    formatNowDate(value) {
      if (!value) return "";
      if (value) {
        return moment(value).fromNow();
      }
    },
    capitalizeFirstLetter(value) {
      if (!value) return "";
      if (value) {
        return value.charAt(0).toUpperCase() + value.slice(1);
      }
    }
  },
  computed: {
    getPages() {
      return this.$route.query.page || 1;
    },
    curPage: {
      get() {
        return this.$route.query.page || 1;
      },
      set(value) {
        this.currentPage = value;
      }
    }
  },
  mounted() {
    const { status, page, name } = this.$route.query;
    if (page) {
      this.currentPage = Number(page);
    }
    if (status) {
      this.status = status;
    }
    if (name) {
      this.searchQuery = name;
    }
    this.getBookings();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/dashboard/booking.vue